module.exports = __webpack_public_path__ + "img/game15.f7187126.png";